const MULTIFORMS = {
  listMultiForms: "Multiforms",
  newMultiForms: "Nuevo",

  activity: "Actividad",
  group: "Grupo",
  totalQestion: "Total Preguntas:",
  company: "Compañía",
  quantity: "Cantidad",
  state: "Estado",
  actions: "Acciones",

  accept: "Aceptar",
  cancel: "Cancelar",

  NOTIFYCATIONS: {
    emptyMultiforms: `No hay multiformularios registrados`,
    titleGetMultiForms: "Lista de Formularios",
  },

  CONFIRM: {
    tittleDeleteMultiForm: "Eliminar MultiForm: {activity}",
    textDeleteMultiForm: "Ésta opción no se puede deshacer, está seguro?",
    ErrorDeleteMultiFormTittle: "Eliminar MultiForm",
    ErrorDeleteMultiFormText: "Ocurrio un error, al eliminar el MultiForm"
  },

  information: "INFORMACIÓN",
  assiciateForms: "Formularios asociados:",

  mulstiStandar: "Formularios standar",
  placeHolderSearch: "Buscar...",
  FormsAdd: "Formularios agregados:",
  save: "Guardar",
  NameToMultiForms: "Nombre para el multiformulario",

  ALERTS: {
    tittleListForms: "Lista de Formularios",
    textAddFormToMulti: "Agregue formularios a la lista",
    nameToForm: "Nombre del Formulario",
    EnterNameToForm: "Ingrese el nombre del formulario",
    titleSelectedGroup: "Selección de Grupo",
    selectedGroup: "Seleccione el grupo"
  },

  success: "Creado!",
  successMultiForm: "MultiFormulario creado.",

  error: "Error!",
  errorMultiForm: "Surgio un error al crear el multiformulario",

};

export default { MULTIFORMS };